import React from 'react'
import SbEditable from 'storyblok-react'
import RichText from '@/utils/RichText'

export type LabelBlok = StoryblokComponent & {
  text: string
  marginTop?: number
  marginBottom?: number
}

export interface LabelProps {
  blok: LabelBlok
}

export const Label = ({ blok }: LabelProps) => {
  const marginTopClass = blok.marginTop ? `${blok.marginTop}px` : ''
  const marginBottomClass = blok.marginBottom ? `${blok.marginBottom}px` : ''

  return (
    <div
      style={{
        marginTop: marginTopClass,
        marginBottom: marginBottomClass,
      }}
    >
      {/** @ts-ignore: Storyblok typing issue with children **/}
      <SbEditable content={blok} key={blok._uid}>
        <div className="text-gray-700 select-none text-sm">
          {blok.text}
        </div>
      </SbEditable>
    </div>
  )
}

Label.displayName = 'Label Block'
